import React from "react";
import Floaticons from "../function-components/Floaticons";
import MenuNavbar from "../function-components/MenuNavbar";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import DeliveryOld from "../function-components/SLFComponents/DeliveryOld";
import Specializations from "../function-components/SLFComponents/Specializations";
import "./SecurityLearningFramework.css";
import { Link } from "react-router-dom";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 4 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function SecurityLearningFramework() {

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>
            <Floaticons />
            <div className="banner-container">
                <img src="images/Banner1.png" alt="banner" className="banner-img" />
                <MenuNavbar />
            </div>
            <div className="main-container">
                <Box className="boxStyles">
                    <Box sx={{ borderBottom: 0, borderColor: 'divider' }} className="tabMenuWrap">
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered>
                            <Tab label="Delivery" {...a11yProps(0)} className="tabStyles" />
                            <Tab label="Specializations" {...a11yProps(1)} className="tabStyles" />
                            <Tab label="Industry" {...a11yProps(2)} className="tabStyles" />
                            <Tab label="Professional" {...a11yProps(3)}
                                className="tabStyles"
                            // href='https://atci.lkm.delivery.accenture.com/ProfessionalSkills/' target='_blank'
                            />
                        </Tabs>
                    </Box>
                    <TabPanel className="tabPanelWrap" value={value} index={0}>
                        <DeliveryOld />
                    </TabPanel>
                    <TabPanel className="tabPanelWrap" value={value} index={1}>
                        <Specializations />
                    </TabPanel>
                    <TabPanel className="tabPanelWrap" value={value} index={2}>
                        <div className="professional-container">
                            <div className="professional-intro">
                                <div className="professional-wrap">
                                    <p>Enhance industry knowledge to have quality conversations with client.</p>
                                    <p className="portal-redirect"><a href='https://atci.lkm-securitylearnings.accenture.com/IndustryLearningAcademy/home' target='_blank'>Click here to visit portal</a></p>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel className="tabPanelWrap" value={value} index={3}>
                        <div className="professional-container">
                            <div className="professional-intro">
                                <div className="professional-wrap">
                                    <p>Enhancing Professional Skills of employees to showcase improved power skills / inter-personal skills which will help managing the human side of the work well when working with teams.</p>
                                    <p className="portal-redirect"><a href="https://atci.lkm.delivery.accenture.com/ProfessionalSkills/" target='_blank'>Click here to visit portal</a></p>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                </Box>
            </div>
        </>
    );
}

export default SecurityLearningFramework;